import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { TabsInnerWrapComponent } from '../../components/tabs-inner-wrap/tabs-inner-wrap.component';
import { SimulationPromptComponent } from './simulation-prompt/simulation-prompt.component';

@Component({
  selector: 'tab-content-details',
  standalone: true,
  templateUrl: './content-detail.component.html',
  styleUrls: ['./content-detail.component.scss'],
  imports: [
    FormsModule,
    CommonModule,
    TabsInnerWrapComponent,
    SimulationPromptComponent
],
})
export class ContentDetailComponent {}
